import React, {Component} from 'react';
import {LayoutSidebar} from "../../Layout";
import AgencySubscriptionContent from "./AgencySubscriptionContent";
import {withRouterParams} from "../../utils/withRouterParams";

class AgencySubscription extends Component {
    render() {
        return (
            <div className="app-content">
                <LayoutSidebar />
                <AgencySubscriptionContent agencyId={this.props.match.params.id}/>
            </div>
        )
    }
}

export default withRouterParams(AgencySubscription);

